import { DecoratorNode, NodeKey, SerializedLexicalNode, Spread } from 'lexical';
import styles from '../RichTextEditor.module.scss';

type SerializedDividerNode = Spread<
  {
    type: 'divider';
    version: 1;
  },
  SerializedLexicalNode
>;

export class DividerNode extends DecoratorNode<JSX.Element> {
  static getType(): string {
    return 'divider';
  }

  static clone(node: DividerNode): DividerNode {
    return new DividerNode(node.__key);
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(key?: NodeKey) {
    super(key);
  }

  createDOM(): HTMLElement {
    const hr = document.createElement('hr');
    hr.className = styles.divider;
    return hr;
  }

  updateDOM(): false {
    return false;
  }

  static importJSON(): DividerNode {
    return new DividerNode();
  }

  exportJSON(): SerializedDividerNode {
    return {
      type: 'divider',
      version: 1,
    };
  }
}

export function createDividerNode(): DividerNode {
  return new DividerNode();
}
